/**
 * Números generadores (OPUS ci, idea 3): utilidades del croquis que toman los visores (IFC y DWG).
 */

/** El lienzo como PNG, reducido a lo más `anchoMax` px (un croquis no necesita la resolución de la pantalla). */
export function reducirLienzo(src: HTMLCanvasElement, anchoMax: number): string {
  const k = Math.min(1, anchoMax / Math.max(1, src.width));
  if (k >= 1) return src.toDataURL('image/png');
  const c = document.createElement('canvas');
  c.width = Math.round(src.width * k);
  c.height = Math.round(src.height * k);
  const ctx = c.getContext('2d');
  if (!ctx) return src.toDataURL('image/png');
  ctx.drawImage(src, 0, 0, c.width, c.height);
  return c.toDataURL('image/png');
}

/**
 * Un croquis tomado del visor: la imagen y, para cruzar tabla y dibujo, dónde cae en ella cada pieza
 * marcada (`x`, `y` en fracción del ancho y alto de la imagen, 0–1). `k` es la clave con que se pidió.
 */
export interface Croquis {
  url: string;
  marcas: { k: string; x: number; y: number }[];
}

/** Qué piezas resalta un croquis del visor 3D (por expressID o por tipo) y cuáles se rotulan. */
export interface PedidoCroquisIfc {
  piezas?: number[];
  etiquetas?: string[];
  marcas?: { k: string; piezas?: number[]; etiquetas?: string[] }[];
}

/** Tamaño fijo del croquis (px): el mismo para todos, así la hoja impresa no depende de la pantalla. */
export const CROQUIS_ANCHO = 1200;
export const CROQUIS_ALTO = 760;
